<div class="container product-quote-outer-container common-text-font">
	<div class="row">
		<div class="col-md-12">
			<form title="productQuoteForm" [formGroup]="productQuoteForm" autocomplete="off">
				<div class="container product-quote-container product-quote-card">
					<div class="row fixed-width">
						<div class="col-md-12">
							<div class="col-md-6 h-100 nav-right top-nav-container"
								*ngIf="loginDetail.customer.registrationStatus">
								<span tabindex="0" id="top-nav-cta-left" name="top-nav-cta-left" (click)="goBack()"
									class="dls-button dls-prev-btn reflect pointer" (keyup.enter)="goBack()">
									<i class="icon1 icon-chevron-left"></i>
									<strong class="nav-btn ml-15 font-weight" id="back-text" role="navigation"
										aria-label="back">{{contentData.backBtn}}</strong>
								</span>
							</div>
						</div>
					</div>
					<app-product-quote-comparison *ngIf="showProductComparison"></app-product-quote-comparison>
					<div class="row mb-2">
						<ng-container *ngIf="isGMPVal === 'Y';else nonGMP">
							<app-gmp-annuity-quote [SelectedGMP]="selectedGMPQuote"
								(riskQuestionEmitter)="openPersonalisedQuote(selectedGMPQuote)"
								(urlEmitter)="downloadAll($event)" [loadingPDFFlag]="loadingPDFFlag"
								[isValidCard]="resultQuote.indicative === 'Y' ? false : true"
								[tileType]="'quote'"></app-gmp-annuity-quote>
						</ng-container>
						<ng-template #nonGMP>
							<app-selected-product-quote *ngIf="selectedProductCode==='C'"
								[Selectedproductquote]="Selectedproductquote"
								(riskQuestionEmitter)="openPersonalisedQuote(Selectedproductquote)"
								(urlEmitter)="downloadAll($event)" [loadingPDFFlag]="loadingPDFFlag"
								[isValidCard]="resultQuote.indicative === 'Y' ? false : true"
								[tileType]="'quote'"></app-selected-product-quote>
							<app-ftrp-product-quote *ngIf="selectedProductCode==='H'"
								[SelectedProductQuoteFTRP]="SelectedProductQuoteFTRP"
								(riskQuestionEmitter)="openPersonalisedQuote(SelectedProductQuoteFTRP)"
								(urlEmitter)="downloadAll($event)" [loadingPDFFlag]="loadingPDFFlag"
								[isValidCard]="resultQuote.indicative === 'Y' ? false : true"
								[tileType]="'quote'"></app-ftrp-product-quote>
							<app-corp-product-quote *ngIf="selectedProductCode==='G'"
								[SelectedProductQuoteCORP]="SelectedProductQuoteCORP"
								(riskQuestionEmitter)="openPersonalisedQuote(SelectedProductQuoteCORP)"
								(urlEmitter)="downloadAll($event)" [loadingPDFFlag]="loadingPDFFlag"
								[isValidCard]="resultQuote.indicative === 'Y' ? false : true"
								[tileType]="'quote'"></app-corp-product-quote>
						</ng-template>
					</div>
					<div class="row error-container">
						<app-modal *ngIf="displayAlert && !noWarningMSg" [modalConfig]="pdfAlertModalConfig"
							(closeModal)="closeModal()" (primaryBtnClick)="alertPrimaryBtnClick()"
							(dontShowUpMsgAgain)="dontShowUPMsgAgain($event)"
							(secondaryBtnClick)="alertSecondaryBtnClick()" 
							[saveDataFlag]="false"></app-modal>
						<div class="col-md-12 indicativeText-padding wd-100" *ngIf="resultQuote['indicative'] === 'Y'">
							<div class="question-info col-md-12 p-0 margintop-30 warning">
								<p [id]="'indicativeResponseText'">{{contentData.indicativeResponseText}}</p>
							</div>
						</div>
						<div class="col-md-12 indicativeText-padding wd-100"
							*ngIf="resultQuote['applyQuoteInd'] === 'N'">
							<div class="question-info col-md-12 p-0 margintop-30 warning">
								<p [id]="'indicativeResponseText'">{{contentData.hoQuoteCantProceed}}</p>
							</div>
						</div>
						<div class="col-md-12 indicativeText-padding" *ngIf="resultQuote['source'] === 'F'">
							<div class="question-info col-md-12 p-0 margintop-30 warning">
								<p [id]="'indicativeResponseText'">{{contentData.slocWarningMessage}}</p>
							</div>
						</div>
						<div *ngIf="isClickApply && !applyFlag" id="quoteDocumentopenflagdiv"
							class="clear-all apply-error-document col-md-12 form-validation-error d-flex">
							<i class="icon icon-error" aria-hidden="true"></i>
							<p style="float: left;margin-left: 1.875rem;" id="quoteDocumentopenflag">
								{{contentData.errorMessagesQuoteDocument}}
							</p>
						</div>
					</div>
					<div class="row">
						<div class="content-container">
							<div class="row flex-50">
								<div class="whats-next-container">
									<div role="heading" aria-level="3" id="whatNext" class="whats-next">
										{{contentData.whatnextLable}}
									</div>
									<p id="whatNextText" class="what-next-text" [innerHTML]="contentData.whatNextText"></p>
									<div class="download-container">
										<button *ngIf="loadingFlag" class="btn btn-primary btn-loading button-download"
											type="button">
											<span class="btn-text">Primary button</span>
											<div class="spinner spinner-white">
												<div class="spinner-ring" aria-hidden="true"></div>
												<span class="access">Loading...</span>
											</div>
										</button>
										<button *ngIf="!loadingFlag" id="btnDownloadAll"
											class="btn-show button-download btn btn-primary" type="button"
											(click)="handleDownloadAll()">{{contentData.downloadAllButton}}</button>
									</div>
								</div>
							</div>
							<div class="clear-all col-md-1" style="width: 7.33333%"></div>
							<div class="row flex-50">
								<div class="apply-container">
									<div class="clear-all col-md-6 border-blue"
										[ngClass]="{'disable-control':resultQuote['indicative'] === 'Y'  || resultQuote['applyQuoteInd'] === 'N' || resultQuote['source'] === 'F'}">
										<div role="heading" aria-level="3" id="decideYourCode"
											class="decided-with-your-quote">
											{{contentData.decideYourQuotLable}}</div>
										<div class="col-md-12 apply-row">
											<div class="col-md-1 pad-0 ">
												<input type="checkbox" id="chkApply" name="chkApply"
													class=" checkbox-override " [formControlName]="'chkApply'"
													aria-invalid="false" [(ngModel)]="isApplySelected"
													[value]="isApplySelected" (change)="onApplyCheckChange()"
													[attr.aria-label]="contentData.decideYourQuoteText?contentData.decideYourQuoteText:'chkApply'"
													[attr.disabled]="(resultQuote['indicative'] === 'Y' || resultQuote['applyQuoteInd'] === 'N' || resultQuote['source'] === 'F') ? '' : null" />
												<label for="chkApply" class="form-label wd-25"
													[attr.aria-label]="contentData.decideYourQuoteText?contentData.decideYourQuoteText:'chkApply'">
													<span
														class="visuallyhidden">{{contentData.decideYourQuoteText}}</span>
												</label>
											</div>
											<span role="heading" id="decideYourCodeText"
												class="clear-all col-md-10 im-ready-to-apply ">
												{{contentData.decideYourQuoteText}}
											</span>

										</div>
										<div *ngIf="ProductQuoteErrorValidatorFlag" id="productError"
											class="clear-all apply-error col-md-12 form-validation-error">
											<i class="icon icon-error" aria-hidden="true"></i>
											<p style="float: left;margin-left: 1.875rem;" id="productChoiceError">
												{{contentData.errorMessages}}</p>
										</div>
										<!-- <button id="btnApply" (click)="applyQuote()" class="btn-show button-apply btn btn-cta btn-chevron" type="button" [disabled]="resultQuote.indicative === 'Y' || !applyFlag">{{contentData.applyButton}}</button> -->
										<div class="button-container">
											<button id="btnApply" (click)="applyQuote()"
												class="btn-show button-apply btn btn-cta btn-chevron"
												type="button">{{contentData.applyButton}}</button>
											<div class="approx-time">
												<small id="btnApply">{{approxQuotationTime}}</small>
											</div>
										</div>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>